import moment from 'moment';
import 'antd/dist/antd.css';
import HostFooter from './HostFooter';
import { push } from 'connected-react-router';
import { useParams, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Cell, Button } from 'react-md';
import { Menu, Dropdown, notification } from 'antd';
import OpenedDatepicker from './Modals/OpenedDatePicker';
import { building, arrow, calendar, time, home, emailBlack, telephone, dropdownIcon, tick, redClose, arrowGreen} from '../Common/Images'
import useWindowDimensions from '../Common/Hooks/useWindowDimensions';
import { CALENDER_DATE_FORMAT } from '../../settings';
import { getCalenderVisitsData, updateVisitStatus, fetchSpaceDetails } from './HostDashboardActions';
import { SPACE_STATUS } from './HostDashboardActionTypes';
import useAuth from '../../hooks/useAuth';
import { USER_HOST, ADMIN, DATE_FORMAT_REVERSE } from '../Common/constants'
import * as constants from './Common/HostDashboardConstants'

const Calendar = () => {
  const { user: loggedUser, isAuthenticated } = useAuth();
  const dispatch = useDispatch();
  const dimensions = useWindowDimensions();
  const { spaceId, status } = useSelector(state => state.router ?.location ?.query);
  const calenderData = useSelector((state) => state?.hostDashboard?.data?.calenderData?.schedulers || []);
  const spaceDetails = useSelector((state) => state?.hostDashboard?.data?.spaceDetails || []);
  const { country } = useParams();
  const location = useLocation().search;
  const dateFromUrl = new URLSearchParams(location).get('startDate');

  const [visitsForTheDate, setVisitsForTheDate] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [visitsForTheFilter,setVisitsForTheFilter] = useState([]);
  const [selectedItem, setSelectedItem] = useState('ALL');

  const mobileView = dimensions.width < 992;
  const isHost = loggedUser && loggedUser.authorities && (loggedUser.authorities[0] === USER_HOST);
  const isAdmin = loggedUser && loggedUser.authorities && (loggedUser.authorities[0] === ADMIN);



  useEffect(() => {
    if (!isAuthenticated) return;
    if(!spaceDetails.length) {
      dispatch(fetchSpaceDetails(spaceId));
    }
    handleDataFetch();
  },[isAuthenticated]);


  useEffect(() =>{
    if (!isAuthenticated) return;
    if(dateFromUrl){
      setSelectedDate(moment(dateFromUrl,CALENDER_DATE_FORMAT));
    }
  },[dateFromUrl, isAuthenticated]);


  useEffect(() => {
    if (!isAuthenticated) return;
    const currentDate = moment(selectedDate).format(DATE_FORMAT_REVERSE);
    if(Object.values(calenderData).length){
      const visits = Object.values(calenderData).flatMap(i =>i).filter(item => item.schedulerStartDate === currentDate);
      setVisitsForTheDate(visits);
      setVisitsForTheFilter(visits)
    }
  }, [selectedDate,calenderData, isAuthenticated]);

  const handleStatus = (data, type) => {
    const { schedulerId:id } = data;
    dispatch(updateVisitStatus({ id, schedulerStatus: type === 1? SPACE_STATUS.ACTIVE:SPACE_STATUS.INACTIVE }, handleDataFetch, visitUpdateNotification));
    handleDataFetch();
  };

  const handleBack = () => {
    const URLtoPush = `/${country}/dashboard/myspaces/${status}/${spaceId}`;
    dispatch(push(URLtoPush));
  };

  const handleDataFetch = () => {
    if (!isAuthenticated) return;
    const startMonth = moment().startOf('month').format(CALENDER_DATE_FORMAT);
    const endMonth = moment().add(3, 'months').format(CALENDER_DATE_FORMAT);
    const payload = {
      startDate: startMonth,
      endDate: endMonth,
    };
    dispatch(getCalenderVisitsData(spaceId, payload));
  };

  const visitUpdateNotification = (status) => {
    notification.open({
      className: 'booking-cancellation-notification',
      message: (
        <span className="title">
          <img src={status ? tick : redClose} alt="arrow" className="icon" />
          <span className="text">{status ? 'Visit updated!' : 'Visit update failed!'}</span>
        </span>
      ),
      duration: 2,
      description: status ? 'You have successfully updated the visit.' : 'Visit update failed.Please try again',
    });
  };

  function handleMenuClick({key}) {
    setSelectedItem(key)
    switch (key) {
      case constants.ALL:
        setVisitsForTheDate(visitsForTheFilter);
        break;
      case constants.ACCEPTED:
        setVisitsForTheDate((visitsForTheFilter).filter(item => item.schedulerStatus === "ACTIVE"));
        break;
      case constants.PENDING:
        setVisitsForTheDate((visitsForTheFilter).filter(item => item.schedulerStatus === "PENDING"));
        break;
      default:
        break;
    }
  }

  const menu = (
    <Menu onClick={handleMenuClick} className="manage-visits-dropdown">
      <Menu.Item key={constants.ALL}>
        <a>{constants.ALL}</a>
      </Menu.Item>
      <Menu.Item  key={constants.PENDING}>
        <a>{constants.PENDING}</a>
      </Menu.Item>
      <Menu.Item key={constants.ACCEPTED}>
        <a>{constants.ACCEPTED}</a>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="my-calendar host-dashboard manage-visit-wrap">
        <div className="header">
          <div className="container custom-container flex-wrap">
            <div className="left">
              <img src={arrow} alt="arrow" onClick={handleBack} className="arrow-img" />
              <h2 className="title">{spaceDetails.spaceName}</h2>
            </div>
            <div className="right">
              <Dropdown overlay={menu} className="manage-visits-filter">
                <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                  {selectedItem}
                </a>
              </Dropdown>
              <img className="icon" src={arrowGreen} />
            </div>
          </div>
        </div>
        <div className="content scrollwrap">
          <div className="mobile-only">
            <OpenedDatepicker data={calenderData} setSelectedDate={setSelectedDate} selectedDate={selectedDate} />
            <img src={dropdownIcon} alt="img" className="img calendar-dropdown-icon" />
          </div>
          <div className="container custom-container">
            <Grid className="calendar-grid">
              <Cell size={5} tabletSize={4} phoneHidden className="spacy-left">
                <OpenedDatepicker data={calenderData} setSelectedDate={setSelectedDate} selectedDate={selectedDate} />
              </Cell>
              <Cell size={7} tabletSize={4} phoneSize={12} className="spacy-right">
                <div className="card-list manage-visits">
                  {visitsForTheDate.length ? (
                    visitsForTheDate.map((visit, index) => {
                      return (
                          <div className="card" key={index}>
                            <div className="content">
                              <div className="title-wrap">
                                <span className="title">{visit?.firstName + ' ' + visit?.lastName}</span>
                                <div className="visit-btn-grp">
                                    {(visit?.schedulerStatus === SPACE_STATUS.PENDING) ? (
                                      <>
                                      {isHost? <> 
                                      <Button onClick={() => { handleStatus(visit, 1);}} className="approve-btn green">
                                          {constants.ACCEPT}
                                        </Button>
                                        <Button onClick={() => {handleStatus(visit, 2);}} className="approve-btn red">
                                          {constants.DECLINE}
                                        </Button> </> : <>
                                        <Button className="status-lable approve " disabled={true} hidden={true}>
                                          {constants.ACCEPTED}
                                        </Button>
                                        <Button className="status-lable reject" disabled={true} hidden={true}>
                                          {constants.DECLINED}
                                        </Button>
                                        </>}
                                        
                                      </>
                                    ) : visit?.schedulerStatus === SPACE_STATUS.ACTIVE ? (
                                      <>
                                        <Button className="status-lable approve " disabled={true}>
                                          {constants.ACCEPTED}
                                        </Button>
                                      </>
                                    ) : (
                                      <>
                                        <Button className="status-lable reject" disabled={true}>
                                          {constants.DECLINED}
                                        </Button>
                                      </>
                                    )}
                                </div>
                              </div>
                              <div className="flex-wrap">
                                {isAdmin && <span className="contact-number detail-block">
                                  <img src={telephone} alt="img" className="telephone-icon" />
                                  {visit?.contactNumber}
                                </span>}
                                <span className="date detail-block">
                                  <img src={calendar} alt="img" className="calendar-img" />
                                  {visit?.schedulerStartDate}
                                </span>
                                {isAdmin && <span className="email detail-block">
                                  <img src={emailBlack} alt="img" className="home-icon" />
                                  {visit?.email}
                                </span>}
                                <span className="time detail-block">
                                  <img src={time} alt="img" className="calendar-img" />
                                  {visit?.schedulerStartTime} {parseInt(visit?.schedulerStartTime) >= 12? 'PM' : 'AM'}
                                </span>
                                {isAdmin && <span className="company-name detail-block">
                                  <img src={home} alt="img" className="home-icon" />
                                  {visit?.companyName && visit?.companyName}
                                </span>}
                              </div>
                              <div className="black-text comment-block"> {visit?.comments}</div>
                            </div>
                          </div>
                      );
                    })
                  ) : (
                    <div className="no-more-wrap">
                      <img alt="img" className="img" src={building} />
                      <p className="title">No Results Found</p>
                      <p className="sub-title">
                        Sorry! We can't seem to find any visits that match your search. <br />
                        Please try a different date.
                      </p>
                    </div>
                  )}
                </div>
              </Cell>
            </Grid>
          </div>
        </div>
      </div>
      {mobileView && <HostFooter />}
    </>
  );
};

export default Calendar;
